import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Concours } from './concours.model';
@Injectable()
export class ConcoursService {

    private resourceUrl = 'api/concours';

    constructor(private http: Http) { }

    create(concours: Concours): Observable<Concours> {
        let copy: Concours = Object.assign({}, concours);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(concours: Concours[]): Observable<Concours[]> {
        let copy: Concours[] = concours.slice(0);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Concours> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.candidatureId) {
            params.set('candidatureId', req.candidatureId);
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    areConcoursValid(concours: Concours[]): any {
        let d = new Date();
        let yearMax = d.getFullYear() + 1;
        for (let i = 0; concours.length > i; i++) {
            if (concours[i].passage == null) {
                return 'passage';
            }
            if (concours[i].passage === true && concours[i].resultat == null) {
                return 'resultat';
            }
            if (concours[i].passage === true && (concours[i].annee < 999 || concours[i].annee > yearMax)) {
                return 'annee';
            }
        }
        return null;
    }



    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/concours.service.ts